class AboutModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalOpen = '.js-about-modal-open';
    const modalWrap = '.js-about-modal';
    const modalContent = '.js-about-modal-content';
    const modalClose = '.js-about-modal-close';
    $(modalOpen).on('click',function(){
      let modalNum = $(this).data('num');
      $(modalContent+':eq('+modalNum+')').css('display','flex');
      $(modalWrap).fadeIn().scrollTop(0);
    })
    $(modalClose).on('click',function(){
      $(modalWrap).fadeOut();
      $(modalContent).fadeOut();
    })
  }
}